import {useMutation, useQueryClient} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpUpdateAccessRates, HttpUpdateAccessRatesOptions} from '../http/budget.http'

export const useUpdateAccessRates = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (variables: HttpUpdateAccessRatesOptions) => httpUpdateAccessRates(variables),
        onSuccess: async () => {
            await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACCESS_RATES]})
        }
    })
}
